import React, { Component } from 'react'
import getBrowserWidth from '../functions/getBrowserWidth'

const hasIsMobile = WrappedComponent => {
    class HasIsMobile extends Component {
        constructor (props) {
            super(props) 
            this.state = {
                isMobile: false
            }
    
            this.updateDimensions = this.updateDimensions.bind(this)
        }
    
        componentDidMount() {
            this.updateDimensions()
            this.debouncedUpdateDimensions = _.debounce(this.updateDimensions, 300)
            window.addEventListener("resize", this.debouncedUpdateDimensions)
        }
    
        componentWillUnmount() {
            this.debouncedUpdateDimensions.cancel()
            window.removeEventListener("resize", this.debouncedUpdateDimensions)
        }
    
        updateDimensions() {
            const isMobile = getBrowserWidth() > 480 ? false : true
    
            if(isMobile !== this.state.isMobile) {
                this.setState({
                    isMobile: isMobile
                })
            }
        }    

        render() {
            const injectedProps = {
                isMobile: this.state.isMobile
            }

            return <WrappedComponent
                {...this.props}
                {...injectedProps}
            />
        }
    }

    return HasIsMobile
}

export default hasIsMobile